var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyInsights(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 102,
    viewBox: "0 0 101 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.2778,
    cy: 50.9414,
    r: 50,
    fill: "#E9ECEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.9311 29.1819H37.1384C36.222 29.1819 35.4802 29.9237 35.4802 30.8401V71.8146C35.4802 72.731 36.0911 73.0364 36.833 72.5128L49.0511 63.6982C49.793 63.1746 51.0148 63.1746 51.7566 63.6982L64.2802 72.5564C65.022 73.0801 65.633 72.7746 65.633 71.8582V30.8401C65.633 29.9237 64.8911 29.1819 63.9311 29.1819ZM59.0439 44.3673L55.4657 47.8582L56.2948 52.7892C56.3384 53.051 56.2511 53.3564 56.0766 53.5746C55.902 53.7928 55.6402 53.8801 55.3784 53.8801C55.2039 53.8801 55.073 53.8364 54.942 53.7492L50.5348 51.4801L46.0839 53.7928C45.6911 54.011 45.2111 53.9237 44.9493 53.5746C44.7748 53.3564 44.6875 53.0946 44.7311 52.7892L45.5602 47.8582L41.982 44.3673C41.7202 44.1055 41.633 43.7564 41.7202 43.4073C41.8075 43.0582 42.113 42.8401 42.462 42.7964L47.4802 42.0982L49.7057 37.6037C49.8802 37.2982 50.1857 37.0801 50.5348 37.0801C50.8839 37.0801 51.1893 37.2982 51.3639 37.6037L53.5893 42.0982L58.5639 42.8401C58.913 42.8837 59.2184 43.1455 59.3057 43.451C59.393 43.7564 59.3057 44.1492 59.0439 44.3673Z",
    fill: "#B2B2B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyInsights);
export default __webpack_public_path__ + "static/media/EmptyInsights.7521968aaa99d526850ef7830058cacc.svg";
export { ForwardRef as ReactComponent };